import failedActionComponent from './failedAction.component';

let failedActionModule = angular.module('vacations-absences.failedAction', [])

.component('failedAction', failedActionComponent)

.name;

export default failedActionModule;



// WEBPACK FOOTER //
// ./client/app/components/failedAction/failedAction.js